import React from 'react'
import Whywe from './Whywe'
import HomeWhatWeAre from './HomeWhatWeAre'
import HomeMainSection from './HomeMainSection'
import Industries from './Industries'
import ExploreKapil from './ExploreKapil'
import { useEffect,useState } from 'react'
import ITConsultingSection from './ITConsultingSection'

import webinar2 from '../../../Assets/webinar/FinalWebinar_1.jpg'
import { Link } from 'react-router-dom'

const HomePage = () => {
 
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <div>
    
     <section className='bg-[white]'>
        <HomeMainSection/>
      </section>

        {/* webinar pages  */}
     <section className="py-2 px-4 bg-gray-50 bg-white">
      <div className="max-w-[95%] mx-auto  bg-white">
        <Link 
          to="/insights/webinar" 
          onClick={scrollToTop}
          className="block"
        >
          <div className="p-2 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-blue-800 mb-2 text-[#00008A]">
              KCS TECH - An Infor Alliance Partner Conducting Infor MES Webinar
            </h2>
            <p className="text-gray-600 mb-4">Join us for an exclusive presentation on Manufacturing Execution System</p>
          </div>
          
          <div className="relative overflow-hidden w-full h-auto  ">
            <img 
              src={webinar2} 
              alt="KCS Tech Infor MES Webinar" 
              className="w-full h-full object-contain "
            />
            
          </div>
        </Link>
      </div>
      </section>

     <section className=" mt-10">
      <HomeWhatWeAre/>
      </section>
      
      <section>
       <Industries/>
      </section>
    
      <section>
        <Whywe/>
      </section>
    
      <section>
        <ITConsultingSection />
      </section>

      <section>
        < ExploreKapil/>
      </section>
      

    


    </div>
  )
}

export default HomePage
